module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-6-2f6e59c59176b07f57b7214a7c46354f.jpg";